module.exports = __webpack_public_path__ + "static/media/boy-clay-body.58328550.gif";